import { pickSetting } from './settingsLayers.js';

export const GLASS_RECOVERY_COPY = 'To restore the window border, right-click it in the taskbar at the bottom 👇 and open Settings.';

export function glassEnabled(widget) {
  return !!pickSetting(widget?.settings, 'glass', !!widget?.maximized);
}

export function glassBorderless(widget) {
  return glassEnabled(widget) && !!pickSetting(widget?.settings, 'glassBorderless', !!widget?.maximized);
}

export function glassDataOnly(widget) {
  return glassEnabled(widget) && !!pickSetting(widget?.settings, 'glassDataOnly', !!widget?.maximized);
}

export function glassChromeHidden(widget) {
  return glassBorderless(widget) || glassDataOnly(widget);
}

export function restoreGlassChromeSettings(settings) {
  const next = { ...(settings || {}), glassBorderless: false, glassDataOnly: false };
  if (settings?.windowed && typeof settings.windowed === 'object') {
    next.windowed = { ...settings.windowed, glassBorderless: false, glassDataOnly: false };
  }
  if (settings?.maximized && typeof settings.maximized === 'object') {
    next.maximized = { ...settings.maximized, glassBorderless: false, glassDataOnly: false };
  }
  return next;
}